import { ReactElement, useMemo, useCallback } from 'react';
import { faVectorSquare as LogisticsZonesIcon } from '@fortawesome/free-solid-svg-icons';

import { RouteReportItemsInProgressZone } from '~services/route/report/types';
import TrackingInTransitDeliveriesList from '~components/TrackingInTransitDeliveriesList';
// eslint-disable-next-line max-len
import { TrackingInTransitDeliveriesItemBase } from '~components/TrackingInTransitDeliveriesList/types';

import { useDashboardVariantV2CarrierContentInTransitTrackingContext } from '../../../Context';

type ZonesDeliveryExtraData = Pick<RouteReportItemsInProgressZone, 'zoneId'>;

const DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabZones =
  (): ReactElement => {
    const {
      tabsData: {
        data: tabsData,
        selectedZoneId: { value: selectedZoneId, setValue: setSelectedZoneId },
      },
    } = useDashboardVariantV2CarrierContentInTransitTrackingContext();

    const zonesDeliveryData = useMemo<
      TrackingInTransitDeliveriesItemBase<ZonesDeliveryExtraData>[]
    >(() => {
      if (!tabsData?.itemsInProgressByZone) return [];

      return tabsData.itemsInProgressByZone.map((zone) => ({
        label: zone.zoneName,
        totalCount: zone.totalItemsInProgress,
        standarCount: zone.totalItemsInProgressNoFlex,
        flexCount: zone.totalItemsInProgressFlex,
        icon: {
          element: LogisticsZonesIcon,
          color: zone.color,
        },
        extraData: { zoneId: zone.zoneId },
        isSelected: selectedZoneId === zone.zoneId,
      }));
    }, [tabsData?.itemsInProgressByZone, selectedZoneId]);

    const handleClickItem = useCallback(
      (extraData: ZonesDeliveryExtraData) => {
        setSelectedZoneId(extraData.zoneId);
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [],
    );

    return (
      <TrackingInTransitDeliveriesList
        data={zonesDeliveryData}
        onClickItem={handleClickItem}
      />
    );
  };

export default DashboardVariantV2CarrierContentInTransitTabTrackingSelectionTabZones;
